import { formatCurrency } from '../../utils/formatCurrency';
import { Button } from '../Button';
import {
  FooterBar,
  FooterDiscountedPrice,
  FooterLeft,
  FooterOriginalPrice,
  FooterPriceRow,
  FooterTitle,
  FooterTotal,
} from './StickyFooter.styles';
import type { StickyFooterProps } from './StickyFooter.types';

export function StickyFooter({
  title,
  totalLabel = 'Total',
  totalAmount,
  originalAmount,
  currencyCode,
  locale = 'en-GB',
  ctaLabel,
  onCtaClick,
  ctaDisabled,
  align,
}: StickyFooterProps) {
  const formattedTotal = formatCurrency(totalAmount, currencyCode, { locale });
  const hasDiscount = originalAmount != null && originalAmount !== totalAmount;
  const originalAmountFormatted = hasDiscount
    ? formatCurrency(originalAmount, currencyCode, { locale })
    : null;

  return (
    <FooterBar $align={align}>
      <FooterLeft>
        <FooterTitle>{title}</FooterTitle>
        {hasDiscount ? (
          <FooterPriceRow>
            <FooterTotal>{totalLabel}</FooterTotal>
            <FooterDiscountedPrice>{formattedTotal}</FooterDiscountedPrice>
            <FooterOriginalPrice>{originalAmountFormatted}</FooterOriginalPrice>
          </FooterPriceRow>
        ) : (
          <FooterTotal>{`${totalLabel} ${formattedTotal}`}</FooterTotal>
        )}
      </FooterLeft>
      <Button variant="primary" size="medium" onClick={onCtaClick} disabled={ctaDisabled}>
        {ctaLabel}
      </Button>
    </FooterBar>
  );
}
